export const APP_ROLES_LIST = {
  super_admin: 'super_admin',
  global_lead: 'global_lead',
  sector_program_lead: 'sector_program_lead',
  bu_manager: 'bu_manager',
  sub_unit_manager: 'sub_unit_manager',
}

export const PROGRAM_NAMES = {
  pfna: 'PFNA',
}

export const ALLOCATION_TYPES = {
  DOMESTIC: 'DOMESTIC',
  OPTIONS: 'OPTIONS',
  IMPORT: 'IMPORT',
  EXPORT: 'EXPORT',
  DISPOSAL: 'DISPOSAL',
}

/**
 * Contract types
 * @type {Object}
 * @property {string} DOMESTIC - Domestic contract
 * @property {string} IMPORT - Import contract
 * @property {string} EXPORT - Export contract
 * @property {string} OPTIONS - Options contract
 * @property {string} AMENDED - Amended contract
 */
export const CONTRACT_TYPES = {
  DOMESTIC: 'Domestic',
  IMPORT: 'Import',
  EXPORT: 'Export',
  OPTIONS: 'Options',
  AMENDED: 'Amended',
}

/**
 * Program Definition section redirect constants
 * @type {Object}
 * @property {string} SECTOR - Program Definition section
 * @property {string} SIZE_RANGE_TAB - Size Range tab
 * @property {string} SEED_CLASSIFICATION_TAB - Seed Classification tab
 */
export const PROGRAM_DEFINITION_SECTION_REDIRECT = {
  SECTOR: 'programDefinition',
  SIZE_RANGE_TAB: '4',
  PRICING_TAB: '1',
  SEED_CLASSIFICATION_TAB: '3',
  CROP_CYCLE_MANAGEMENT_TAB: '2',
  BASE_PRICE_TYPE: 'base',
  VUF_PRICE_TYPE: 'vuf',
  STORAGE_COST_TYPE: 'storage',
  BROKER_FEE_TYPE: 'brokerFee',
}

export const SUPPLIER_SECTION_REDIRECT = {
  SECTION: 'supplier',
}

export const LANDING_PAGE_PLANNING_HORIZON_STATUS = {
  SURPLUS: 'Surplus',
  SHORTAGE: 'Shortage',
  BALANCED: 'Balanced',
}
/**
 * Base price model options
 * @type {Object}
 * @property {string} FLAT_RATE - Flat rate
 * @property {string} MONTHLY_RATE - Monthly rate
 * @property {string} WEEKLY_RATE - Weekly rate
 */
export const BASE_PRICE_MODEL_OPTIONS = [
  { id: 0, displayText: 'Flat Rate' },
  { id: 1, displayText: 'Monthly Rate' },
  { id: 2, displayText: 'Weekly Rate' },
]

/**
 * VUF based on options
 * @type {Object}
 * @property {string} QUANTITY - Quantity
 * @property {string} VARIETY - Variety
 * @property {string} CONTRACT_TYPE - Contract type
 */
export const VUF_BASED_ON_OPTIONS = [
  { id: 0, displayText: 'Quantity' },
  { id: 1, displayText: 'Variety' },
  { id: 2, displayText: 'Contract Type' },
]

/**
 * Contract allocation type id mapping
 */
export const DEMAND_ALLOCATION_TYPE_MAPPING = {
  Domestic: 7,
  Export: 8,
  Options: 6,
}
